import { ASSETS as ASSETS_PATH } from './constants/paths';

export const getAssetUrl = (assetName: string) => ASSETS_PATH + assetName;
